<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1>{{ $t('tenants.report') }}</h1>
    </div>
    <div class="details-component__content content">
      <form class="form fixed-form">
        <table class="details-table tenant no-col-padding edit-table fixed-table label-col-wide-150">

          <tr class="details-table__row" :class="{ 'details-table__row_error': errors.has('tenants') }">
            <td class="details-table__col details-table__col_label">
              <label for="tenants" class="form__label">{{ $t('common.tenants') }}</label>
            </td>
            <td class="details-table__col">
              <el-select name="tenant" placeholder="" v-model="tenantId" v-if="tenants.items" clearable>
                <el-option v-for="tenant in tenants.items" :key="tenant.id" :label="tenant.name" :value="tenant.id">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr class="details-table__row" :class="{ 'details-table__row_error': errors.has('product') }">
            <td class="details-table__col details-table__col_label">
              <label for="product" class="form__label">{{ $t('common.product') }}</label>
            </td>
            <td class="details-table__col">
              <el-select name="product" v-model="productId" clearable placeholder=""
                v-if="products.items && products.items.length > 0">
                <el-option v-for="product in products.items" :key="product.id" :label="product.name"
                  :value="product.id">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr class="details-table__row">
            <td class="details-table__col details-table__col_label">
              <label for="decimal-separator" class="form__label">{{ $t('parking.decimal_separator') }}</label>
            </td>
            <td class="details-table__col">
              <el-select name="decimal-separator" v-model="decimalSeparator" clearable placeholder=""
                @change="resetColumnSeparator()">
                <el-option v-for="separator in decimalSeparators" :key="separator.value" :label="separator.label"
                  :value="separator.value">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr class="details-table__row">
            <td class="details-table__col details-table__col_label">
              <label for="column-separator" class="form__label">{{ $t('parking.column_separator') }}</label>
            </td>
            <td class="details-table__col">
              <el-select name="decimal-separator" v-model="columnSeparator" clearable placeholder=""
                @change="updateLocalStorage()">
                <el-option v-for="separator in columnSeparators" :key="separator.value" :label="separator.label"
                  :value="separator.value">
                </el-option>
              </el-select>
            </td>
          </tr>
        </table>
        <div class="form__buttons buttonset">
          <router-link :to="{ name: 'tenants' }" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <button type="submit" class="buttonset__button btn btn--main" @click.prevent.stop="onSubmit()">
            {{ $t('report.generate') }}
          </button>
          <a v-if="downloadLink && !downloadLink.ie" class="buttonset__button btn btn--main" :href="downloadLink.href"
            :download="downloadLink.download" @click="removeDownloadLink()">
            {{ downloadLink.name }}
          </a>
          <a v-if="downloadLink && downloadLink.ie" class="buttonset__button btn btn--main" :href="downloadLink.href"
            @click.prevent="downloadLink.ie()">
            {{ downloadLink.name }}
          </a>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { format } from 'libphonenumber-js';
import { mapGetters } from 'vuex';
import moment from 'moment';
import json2csv from 'json2csv';

export default {
  components: {
  },
  computed: mapGetters({
    products: 'landlord/products/products',
    tenants: 'landlord/tenants/tenants',
  }),
  created() {
    if (localStorage.getItem('report-generator')) {
      const reportGeneratorParams = JSON.parse(localStorage.getItem('report-generator'));
      this.decimalSeparator = reportGeneratorParams.decimalSeparator;
      this.columnSeparator = reportGeneratorParams.columnSeparator;
    }
    this.fetchProducts();
    this.fetchTenants();
  },
  data() {
    return {
      form: {},
      decimalSeparator: '.',
      columnSeparator: ',',
      decimalSeparators: [
        {
          value: '.',
          label: '.',
        },
        {
          value: ',',
          label: ',',
        },
      ],
      columnSeparators: [
        {
          value: ',',
          label: ',',
        },
        {
          value: ';',
          label: ';',
        },
        {
          value: '\t',
          label: 'tab',
        },
      ],
      downloadLink: null,
      reportFieldNames: [
        'Product ID',
        'Product Name',
        'Can Exceed?',
        'Total',
        'Issued',
        'Partner ID',
        'Partner Name',
        'Partner Contact',
        'Partner Email',
        'Partner Phone',
        'Partner Permits',
        'Landlord ID',
        'Landlord Name',
        'Product Zones',
      ],
      reportFields: [
        'id',
        'name',
        'canExceedCapacity',
        'total',
        'issued',
        'partnerId',
        'partnerName',
        'partnerContactPerson',
        'partnerEmail',
        'partnerPhone',
        'partnerPermits',
        'landlordId',
        'landlordName',
        'zones',
      ],
      totalFields: [],
      productId: null,
      tenantId: null,
    };
  },
  methods: {
    fetchProducts() {
      if (this.user) {
        this.$store.dispatch('landlord/products/fetch', { user: this.user, type: 'permitPack', limit: 200 });
      }
    },
    fetchTenants() {
      if (this.user.data) {
        this.$store.dispatch('landlord/tenants/list', { user: this.user });
      }
    },
    onSubmit() {
      this.$validator.validateAll()
        .then((success) => {
          if (!success) {
            return;
          }
          this.form.productId = this.productId;
          this.form.tenantId = this.tenantId;
          this.$store.dispatch('landlord/tenants/fetchReport', { user: this.user, data: this.form })
            .then((response) => {
              const data = response.data.items.map((item) => {
                if (item.partnerPhone) {
                  item.partnerPhone = format({ country: item.partnerPhoneCountry, phone: item.partnerPhone.toString() }, 'International_plaintext');
                }
                return item;
              });
              this.generateReport(data, response.data.totals);
            });
        })
        .catch(() => {
        });
    },
    generateReport(items, totals) {
      let csvFieldNames = this.reportFieldNames;
      let csvFields = this.reportFields;

      if (this.isLandlord()) {
        csvFieldNames = [
          'Product ID',
          'Product type',
          'Product Name',
          'Can Exceed?',
          'Total',
          'Issued',
          'Price',
          'Issued * Price',
          'Partner ID',
          'Partner Name',
          'Partner Contact',
          'Partner Email',
          'Partner Phone',
          'Partner Permits',
          'Landlord ID',
          'Landlord Name',
          'Concurrent Sessions limit',
          'Product Zones',
        ];
        csvFields = [
          'id',
          'type',
          'name',
          'canExceedCapacity',
          'total',
          'issued',
          'price',
          'priceIssued',
          'partnerId',
          'partnerName',
          'partnerContactPerson',
          'partnerEmail',
          'partnerPhone',
          'partnerPermits',
          'landlordId',
          'landlordName',
          'concurrentParkings',
          'zones',
        ];
      }

      const report = json2csv({
        data: items,
        fields: csvFields,
        fieldNames: csvFieldNames,
        del: this.columnSeparator,
      });
      const total = json2csv({
        data: totals,
        fields: this.totalFields,
        hasCSVColumnTitle: false,
        del: this.columnSeparator,
      });
      const all = `${report}\n${total}`;
      this.generateExcelLink(all);
    },
    clearProduct() {
      this.productId = null;
    },
    generateExcelLink(csv) {
      const blob = new Blob([csv], { type: 'text/csv' });
      const date = moment().format('YYYY-MM-DD-HHmmss');
      const fileName = `tenants_${date}`;
      this.downloadLink = {};
      this.downloadLink.name = this.$t('common.download_report');

      if (window.navigator.msSaveOrOpenBlob) {
        this.downloadLink.href = `${fileName}.csv`;
        this.downloadLink.ie = () => {
          window.navigator.msSaveOrOpenBlob(blob, this.downloadLink.download);
          this.removeDownloadLink();
        };
      } else {
        this.downloadLink.href = window.URL.createObjectURL(blob);
        this.downloadLink.download = `${fileName}.csv`;
      }
    },
    base64(s) {
      return window.btoa(unescape(encodeURIComponent(s)));
    },
    removeDownloadLink() {
      this.downloadLink = null;
      this.form = {};
      this.startDate = null;
      this.endDate = null;
      this.productId = null;
    },
    resetColumnSeparator() {
      if (!this.storedColumnSeparators) {
        this.storedColumnSeparators = this.columnSeparators;
      }
      this.columnSeparators = [];
      this.storedColumnSeparators.forEach((item) => {
        if (item.value !== this.decimalSeparator) {
          this.columnSeparators.push(item);
        }
      });
      this.columnSeparator = this.columnSeparators[0].value;
      this.updateLocalStorage();
    },
    updateLocalStorage() {
      localStorage.setItem('report-generator', JSON.stringify(
        {
          decimalSeparator: this.decimalSeparator,
          columnSeparator: this.columnSeparator,
        },
      ));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tenants/ExportTenantsForm.vue